import objectUtils from '../utils/object-utils'

export default class OrgMembershipInvite {
  constructor (options = {}) {
    this.model = 'OrgMembershipInvite'

    this.org_id = objectUtils.get(options, 'org_id', null)
    this.member_email = objectUtils.get(options, 'member_email', null)
    this.member_roles = objectUtils.get(options, 'member_roles', null)

    // Invite status
    this.status = objectUtils.get(options, 'status', null)
    this.expires_at = objectUtils.get(options, 'expires_at', null)

    // Auditing
    this.invited_by = objectUtils.get(options, 'invited_by', null)
    this.accepted_at = objectUtils.get(options, 'accepted_at', null)
    this.canceled_at = objectUtils.get(options, 'canceled_at', null)
    this.canceled_by = objectUtils.get(options, 'canceled_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.org) this.org = options.org
    if (options.inviter) this.inviter = options.inviter
    if (options.user) this.user = options.user
  }
}
